import script from "./PdfImg.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfImg.vue?vue&type=script&setup=true&lang=js"

import "./PdfImg.vue?vue&type=style&index=0&id=5f40ca9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f40ca9d"]])

export default __exports__